import React from 'react'

import { mainColors } from '../../styles'
import { Tooltip } from '../Tooltip'
import * as S from './TimelineBar.styles'
import { TimelineBarProps } from './TimelineBar.types'

export const TimelineBar = <LineId,>({
  highlightedLine,
  lines,
  shouldDisplayExtremes = true,
}: TimelineBarProps<LineId>) => {
  const getIsHighlighted = (lineId: LineId) => highlightedLine === lineId
  const getTextAlign = (lineIndex: number) => (lineIndex === 0 ? 'left' : 'right')

  return (
    <S.Root>
      <S.LineWrapper>
        {lines.map((line, index) => (
          <Tooltip key={`line-${line.id}-${index}`} content={line.tooltip} placement="top">
            <S.LineStage color={line.color} isHighlighted={getIsHighlighted(line.id)} />
          </Tooltip>
        ))}
      </S.LineWrapper>
      <S.LineWrapper>
        {lines.map((line, index) => {
          const isHighlighted = getIsHighlighted(line.id)
          const isExtremeVisible = shouldDisplayExtremes
            ? (!isHighlighted && index === 0) || (!isHighlighted && index === lines.length - 1)
            : false

          return (
            <S.LineTitle
              key={`title-${line.id}-${index}`}
              color={isHighlighted ? line.color : mainColors.neutralExtraDark}
              isHighlighted={isHighlighted}
              isVisible={isHighlighted || isExtremeVisible}
              textAlign={!isHighlighted ? getTextAlign(index) : undefined}
            >
              {line.title}
            </S.LineTitle>
          )
        })}
      </S.LineWrapper>
    </S.Root>
  )
}
